import "../data/css/Main.scss"
import {useEffect, useState} from "react";
import {useGlobal} from "../contexts/GlobalContext";

export default function Main() {
    const [funWord, setFunWord] = useState('')
    const {setSideBarShow} = useGlobal()

    const changeWord = (word, time) => {
        setTimeout(function () {
            setFunWord(word)
        }, time);
    }

    const funWords = [
        // 'exciting', 'wonderful', 'epic',
        // 'amazing',
        // 'astonishing',
        // 'awesome',
        // 'brilliant',
        // 'cool',
        // 'enjoyable',
        // 'excellent',
        // 'fabulous',
        //
        // 'incredible',
        // 'magnificent',

        // 'outstanding',
        // 'phenomenal',
        // 'remarkable',
        'sensational',
        'superb',
        // 'surprising',
        'tremendous',
        'wondrous',
        'astounding',
        'marvelous',
        'miraculous',
        'outstanding']

    useEffect(() => {
        let time = 1000 + funWords.length * 200;
        for (let i = 0; i < funWords.length; i++) {

            changeWord(funWords[i], 1000 + i * 200)
        }
        setTimeout(function () {
            setSideBarShow(true)
        }, time + 1000);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div className={"main"}>
            <h1 className={"a-1 text-center"}>Hello. </h1>
            <h3 className={"a-2 text-center"}>Let's make an <span className={"color-special"}>{funWord}</span> app
            </h3>
        </div>

    )
        ;
}


